import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { MORE_VERT_ROUNDED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const MoreVertRoundedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={MORE_VERT_ROUNDED_GLYPH} />;
